import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/MemberAuthContext';
import SkillPicker from '../components/SkillPicker';

export default function Register() {
  const navigate = useNavigate();
  const { register } = useAuth();
  const [step, setStep] = useState(1);
  const [form, setForm] = useState({
    first_name: '', last_name: '', email: '', phone: '', password: '', join_code: '',
  });
  const [skills, setSkills] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  // Krok 1 → 2: ověř osobní údaje, pak přejdi na schopnosti.
  const goToSkills = (e) => {
    e.preventDefault();
    setError('');
    if (form.password.length < 10) {
      setError('Heslo musí mít alespoň 10 znaků.');
      return;
    }
    setStep(2);
  };

  // Krok 2: dokonči registraci včetně schopností.
  const submit = async () => {
    setError('');
    setLoading(true);
    try {
      await register({
        ...form,
        email: form.email.trim(),
        join_code: form.join_code.trim().toUpperCase(),
        skills,
      });
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Registrace selhala');
      setStep(1); // chyba bývá v osobních údajích / kódu – vrať na 1. krok
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container" style={{ paddingTop: 40 }}>
      <div className="card">
        <div className="text-center mb-16">
          <img src="/logo.svg" width="56" height="56" alt="TEČČKa" style={{ borderRadius: 12 }} />
          <h1 style={{ marginTop: 10 }}>Registrace člena</h1>
          <p className="text-muted">
            {step === 1 ? 'Připojte se ke svému oblastnímu spolku' : 'Co umíte? (krok 2 ze 2)'}
          </p>
        </div>

        {/* Indikátor kroků */}
        <div style={{ display: 'flex', gap: 6, marginBottom: 20 }}>
          {[1, 2].map((n) => (
            <span key={n} style={{
              flex: 1, height: 4, borderRadius: 999,
              background: step >= n ? 'var(--red)' : 'var(--border)',
            }} />
          ))}
        </div>

        {error && <div className="alert alert-warning mb-16">{error}</div>}

        {step === 1 ? (
          <form onSubmit={goToSkills}>
            <div className="flex gap-8">
              <div className="form-group flex-1">
                <label>Jméno</label>
                <input className="form-input" value={form.first_name} onChange={set('first_name')} required />
              </div>
              <div className="form-group flex-1">
                <label>Příjmení</label>
                <input className="form-input" value={form.last_name} onChange={set('last_name')} required />
              </div>
            </div>
            <div className="form-group">
              <label>E-mail</label>
              <input type="email" className="form-input" value={form.email} onChange={set('email')} autoComplete="username" required />
            </div>
            <div className="form-group">
              <label>Telefon <span className="text-muted">(volitelné)</span></label>
              <input className="form-input" value={form.phone} onChange={set('phone')} />
            </div>
            <div className="form-group">
              <label>Heslo <span className="text-muted">(min. 10 znaků)</span></label>
              <input type="password" className="form-input" value={form.password} onChange={set('password')} autoComplete="new-password" required />
            </div>
            <div className="form-group">
              <label>Připojovací kód spolku</label>
              <input className="form-input" value={form.join_code} onChange={set('join_code')}
                placeholder="XXXX-XXXX" autoCapitalize="characters" style={{ fontFamily: 'monospace', letterSpacing: '0.1em' }} required />
              <p className="text-muted" style={{ fontSize: '0.8rem', marginTop: 4 }}>
                Kód vám poskytne zástupce vašeho oblastního spolku.
              </p>
            </div>
            <button type="submit" className="btn btn-primary btn-full">Pokračovat</button>
          </form>
        ) : (
          <div>
            <p className="text-muted mb-16" style={{ fontSize: '0.9rem' }}>
              Vyberte oblasti, ve kterých máte výcvik nebo zkušenosti. Pomůže to operačnímu středisku
              při povolávání. Můžete vybrat víc možností i nic – upravíte kdykoli v Nastavení účtu.
            </p>
            <SkillPicker value={skills} onChange={setSkills} />
            <div className="flex gap-8 mt-24">
              <button type="button" className="btn btn-outline" onClick={() => setStep(1)} disabled={loading}>Zpět</button>
              <button type="button" className="btn btn-primary flex-1" onClick={submit} disabled={loading}>
                {loading ? 'Vytvářím účet…' : 'Dokončit registraci'}
              </button>
            </div>
          </div>
        )}

        <p className="text-center text-muted mt-16" style={{ fontSize: '0.9rem' }}>
          Už máte účet? <Link to="/login">Přihlaste se</Link>
        </p>
      </div>
    </div>
  );
}
